var map = {
	"./ag.png": "78cb",
	"./amg.png": "fb85",
	"./hunter.png": "cd54",
	"./sport.png": "a4a0",
	"./xin.png": "8e14",
	"./yoplay.png": "19c1",
	"./yoplay1.png": "1970"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";